import { getFrequencyLabel } from "library/get-frequency-label.mjs"
import { getComparisonNormalizeString } from "routes/schedule/compare/get-comparison-normalizer"

export function findTaskComparison(originalTask, target, skills, taskName) {
    if (!originalTask || !target) return [{}, {}]
    const normalizeString = getComparisonNormalizeString(originalTask, target)
    originalTask.skill = skills[originalTask.skillSet] ?? originalTask.skill
    target.skill = skills[target.skillSet] ?? target.skill
    const separateIntroField =
        taskName === "intro.content" || taskName === "intro.note" ? taskName.split("intro.").at(1) : null
    if (separateIntroField) {
        return compareIntroField({
            originalTask,
            target,
            introFieldName: separateIntroField,
        })
    }
    const list = Array.from(new Set([...Object.keys(originalTask), ...Object.keys(target)]))
    let include = ["unitOfMeasure", "classification", "content", "frequency", "skill", "note", "title", "minutes"]
    if (taskName === "intro") {
        include = ["intro"]
    }
    if (taskName === "details") {
        include = ["title"]
    }
    if (taskName === "details:code") {
        include = ["code"]
    }
    if (taskName === "details:unitOfMeasure") {
        include = ["unitOfMeasure"]
    }
    const filtered = list.filter((l) => include.includes(l))
    let original = {}
    let tailored = {}
    filtered.forEach((name) => {
        const v1 = Object.get(originalTask, name, true)
        const v2 = Object.get(target, name, true)
        if (typeof v2 === "string" && typeof v1 === "string") {
            if (normalizeString(v1) !== normalizeString(v2)) {
                original[name] = v1
                tailored[name] = v2
            }
        } else if (typeof v2 === "object" && typeof v1 === "object" && v2 !== null && v1 !== null) {
            const [nested1, nested2] = compareRecursively(v1, v2)
            if (Object.keys(nested1).length > 0 || Object.keys(nested2).length > 0) {
                if (name === "frequency") {
                    original[name] = getFrequencyLabel(v1)
                    tailored[name] = getFrequencyLabel(v2)
                } else {
                    original[name] = nested1
                    tailored[name] = nested2
                }
            }
        } else if (v1 !== v2) {
            original[name] = v1 ?? null
            tailored[name] = v2 ?? null
        }
    })

    return [original, tailored]

    function compareRecursively(nestedOriginal, nestedTarget) {
        const diff1 = {}
        const diff2 = {}
        const keys = Object.keys(nestedOriginal)
        keys.forEach((key) => {
            const v1 = Object.get(nestedOriginal, key, true)
            const v2 = Object.get(nestedTarget, key, true)
            if (typeof v2 === "object" && typeof v1 === "object" && v2 !== null && v1 !== null) {
                const [nested1, nested2] = compareRecursively(v1, v2)
                if (Object.keys(nested1).length > 0 || Object.keys(nested2).length > 0) {
                    diff1[key] = nested1
                    diff2[key] = nested2
                }
            } else if (v1 !== v2) {
                diff1[key] = v1 ?? null
                diff2[key] = v2 ?? null
            }
        })
        return [diff1, diff2]
    }
}

function compareIntroField({ originalTask, target, introFieldName }) {
    const originalValue = Object.get(originalTask, `intro.${introFieldName}`, true)
    const targetValue = Object.get(target, `intro.${introFieldName}`, true)
    const normalizeString = getComparisonNormalizeString(originalTask, target)
    const valuesMatch =
        typeof originalValue === "string" && typeof targetValue === "string"
            ? normalizeString(originalValue) === normalizeString(targetValue)
            : originalValue === targetValue

    if (valuesMatch) return [{}, {}]

    return [{ intro: { [introFieldName]: originalValue } }, { intro: { [introFieldName]: targetValue } }]
}
